export default __webpack_public_path__ + "static/media/hiker.4677330b.png";